var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShotgunVariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M115.351 17.442C115.351 17.442 83.6482 17.496 83.4817 17.496C83.3152 17.496 82.1512 18.3825 82.1512 18.3825H80.7097L80.3212 17.796H73.1017L71.6752 18.3825L62.6602 18.168L62.0887 17.5395L60.0082 16.8555L58.4287 16.719C58.4287 16.719 57.4702 15.141 57.2377 14.925C57.0067 14.709 55.7677 14.7225 55.7677 14.7225L55.3792 13.947H53.9377L51.4642 15.2775L53.9932 15.9975V16.6575L51.4642 16.9395H23.2912L15.4897 14.7495L12.9262 14.6685L11.1802 15.999L11.7067 16.8855V18.3825L10.5427 17.883L9.91866 18.2565H8.56716L8.06766 17.7945H4.76616C4.76616 17.7945 4.10166 19.6005 4.13166 19.9095C4.16316 20.2185 4.74516 21.4995 4.74516 21.4995H6.42816V22.7055H4.30866L3.47766 23.2245V24.9495L4.30866 25.449L11.3542 25.3665L11.7277 26.883H7.19616L6.36516 27.4305L6.10866 29.3535L7.28016 30.1665L10.9312 30.36L12.1027 29.937L13.0312 29.874L14.2132 32.5005L16.5187 32.679L17.5477 32.1795L17.9017 30.33L19.3777 29.8725H24.4912L25.3852 30.891L30.2902 31.9095H32.0782L33.3052 32.346L34.4692 31.9095L35.9317 32.325L36.9217 31.9305L37.6987 31.9095L38.5852 32.346L40.5082 31.9095L41.7337 32.367L43.3177 31.9095L44.9452 32.388L46.1092 31.9095L48.1807 31.9725L48.7492 31.599L49.8997 30.795L54.7357 30.5865L55.7752 29.52L55.8172 27.5805H65.5852L67.1377 27.8445V31.128L67.9132 30.2565H69.0772V30.9075H82.1572C83.3767 30.9075 83.7652 31.794 83.7652 31.794C83.7652 31.794 85.4932 36.153 85.6507 36.7365C85.8082 37.32 85.8217 38.118 85.6732 38.781C85.5262 39.444 86.1457 39.6285 86.1457 39.6285C86.1457 39.6285 89.2252 38.6985 90.5317 38.2455C91.8382 37.7925 91.1707 36.357 91.1707 36.357L90.0037 33.156L89.1352 31.6005C89.1352 31.6005 88.0867 29.991 87.9157 28.7265C87.7447 27.4635 88.7662 26.9835 89.8552 26.088C90.9442 25.191 92.2987 25.0395 92.2987 25.0395L96.0127 25.089C96.0127 25.089 96.7537 26.0385 97.0717 26.181C97.3897 26.3235 100.778 26.9175 104.77 27.1065C108.761 27.2955 110.866 32.46 110.866 32.46L113.315 32.166L114.583 32.46H115.855L117.352 30.852V18.384L115.357 17.442H115.351ZM11.7082 22.998H9.70266L9.08916 22.3125H7.69716V21.5025H8.23716L8.67366 21.108H9.92016L10.3147 21.306L10.8757 21.0045H11.7067V22.9995L11.7082 22.998ZM16.4197 22.998H13.1227V21.003H16.4197V22.998ZM17.9722 21.003H21.2422V22.998H17.9722V21.003ZM25.0657 26.796H19.4677L18.8857 25.284H25.0657V26.796V26.796ZM82.6507 29.7465H76.1932V27.4455H82.6507V29.7465Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.882 22.7955V31.893",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6503 18.9854H109.206V21.7079H100.206V20.1284H88.6503C88.6503 20.1284 87.9229 20.1284 87.9229 19.5464C87.9229 18.9644 88.6503 18.9854 88.6503 18.9854V18.9854Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1514 18.3839V21.3764",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7111 18.384V21.543",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1035 23.0385L74.6425 24.771H82.435",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6006 27.5835V28.8315H73.0631V27.5835",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3348 24.2235V26.343H69.9033L69.2793 25.908V24.771L69.8613 24.2235H72.3348Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9453 21.543V20.691H71.4408V21.543",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3444 18.3839H19.1484C18.8502 18.3839 18.6084 18.6257 18.6084 18.9239V18.9254C18.6084 19.2236 18.8502 19.4654 19.1484 19.4654H24.3444C24.6426 19.4654 24.8844 19.2236 24.8844 18.9254V18.9239C24.8844 18.6257 24.6426 18.3839 24.3444 18.3839Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7624 18.3839H27.5664C27.2681 18.3839 27.0264 18.6257 27.0264 18.9239V18.9254C27.0264 19.2236 27.2681 19.4654 27.5664 19.4654H32.7624C33.0606 19.4654 33.3024 19.2236 33.3024 18.9254V18.9239C33.3024 18.6257 33.0606 18.3839 32.7624 18.3839Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1801 18.384H35.9841C35.6859 18.384 35.4441 18.6257 35.4441 18.924V18.9255C35.4441 19.2237 35.6859 19.4655 35.9841 19.4655H41.1801C41.4783 19.4655 41.7201 19.2237 41.7201 18.9255V18.924C41.7201 18.6257 41.4783 18.384 41.1801 18.384Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5966 18.384H44.4006C44.1024 18.384 43.8606 18.6257 43.8606 18.924V18.9255C43.8606 19.2237 44.1024 19.4655 44.4006 19.4655H49.5966C49.8948 19.4655 50.1366 19.2237 50.1366 18.9255V18.924C50.1366 18.6257 49.8948 18.384 49.5966 18.384Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0143 18.3839H52.8183C52.5201 18.3839 52.2783 18.6257 52.2783 18.9239V18.9254C52.2783 19.2236 52.5201 19.4654 52.8183 19.4654H58.0143C58.3126 19.4654 58.5543 19.2236 58.5543 18.9254V18.9239C58.5543 18.6257 58.3126 18.3839 58.0143 18.3839Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0761 31.914C32.0761 31.914 31.5766 30.387 31.8271 26.796H33.5731C33.5731 26.796 33.3451 31.083 33.8851 31.914",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8857 31.914C34.8857 31.914 34.3862 30.387 34.6367 26.796H36.3827C36.3827 26.796 36.1547 31.083 36.6947 31.914",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6953 31.914C37.6953 31.914 37.1958 30.387 37.4463 26.796H39.1923C39.1923 26.796 38.9643 31.083 39.5043 31.914",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5048 31.914C40.5048 31.914 40.0053 30.387 40.2558 26.796H42.0018C42.0018 26.796 41.7738 31.083 42.3138 31.914",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3145 31.914C43.3145 31.914 42.815 30.387 43.0655 26.796H44.8115C44.8115 26.796 44.5835 31.083 45.1235 31.914",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3008 26.2815H31.9518V27.009",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8113 26.2815C29.8113 26.2815 29.4573 30.3555 29.9148 31.602",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3036 26.925V29.877",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0656 26.2815V25.4505H46.6881V26.796H44.8116",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0827 24.516C38.1174 24.516 38.1457 24.4877 38.1457 24.453C38.1457 24.4182 38.1174 24.39 38.0827 24.39C38.0479 24.39 38.0197 24.4182 38.0197 24.453C38.0197 24.4877 38.0479 24.516 38.0827 24.516Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2778 24.516C39.3126 24.516 39.3408 24.4878 39.3408 24.453C39.3408 24.4182 39.3126 24.39 39.2778 24.39C39.2431 24.39 39.2148 24.4182 39.2148 24.453C39.2148 24.4878 39.2431 24.516 39.2778 24.516Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4732 24.516C40.508 24.516 40.5362 24.4878 40.5362 24.453C40.5362 24.4182 40.508 24.39 40.4732 24.39C40.4384 24.39 40.4102 24.4182 40.4102 24.453C40.4102 24.4878 40.4384 24.516 40.4732 24.516Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6675 24.516C41.7023 24.516 41.7305 24.4877 41.7305 24.453C41.7305 24.4182 41.7023 24.39 41.6675 24.39C41.6327 24.39 41.6045 24.4182 41.6045 24.453C41.6045 24.4877 41.6327 24.516 41.6675 24.516Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8628 24.516C42.8976 24.516 42.9258 24.4878 42.9258 24.453C42.9258 24.4182 42.8976 24.39 42.8628 24.39C42.828 24.39 42.7998 24.4182 42.7998 24.453C42.7998 24.4878 42.828 24.516 42.8628 24.516Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0591 24.516C44.0939 24.516 44.1221 24.4878 44.1221 24.453C44.1221 24.4182 44.0939 24.39 44.0591 24.39C44.0243 24.39 43.9961 24.4182 43.9961 24.453C43.9961 24.4878 44.0243 24.516 44.0591 24.516Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2544 24.516C45.2892 24.516 45.3174 24.4878 45.3174 24.453C45.3174 24.4182 45.2892 24.39 45.2544 24.39C45.2196 24.39 45.1914 24.4182 45.1914 24.453C45.1914 24.4878 45.2196 24.516 45.2544 24.516Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M51.038 26.547C51.1234 26.547 51.1925 26.4778 51.1925 26.3925C51.1925 26.3071 51.1234 26.238 51.038 26.238C50.9527 26.238 50.8835 26.3071 50.8835 26.3925C50.8835 26.4778 50.9527 26.547 51.038 26.547Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2097 26.025C52.2097 25.378 51.6855 24.8535 51.0389 24.8535C50.3923 24.8535 49.8682 25.378 49.8682 26.025V28.365C49.8682 29.012 50.3923 29.5365 51.0389 29.5365C51.6855 29.5365 52.2097 29.012 52.2097 28.365V26.025Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4531 23.9055H55.5406H66.7021",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5986 22.8345H51.4666H66.6046",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4668 23.7465V22.8345",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7314 23.7465V22.8345",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9941 23.7465V22.8345",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2576 23.7465V22.8345",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5205 23.7465V22.8345",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8105 27.5835V23.9055",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M55.957 24.771H66.391",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M55.957 26.343H64.2715V27.4665",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5536 21.543L54.1911 20.3235H57.9936L58.8186 21.7095",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1553 21.0165V24.1815",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7139 21.543V23.496",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4658 21.501V23.2905",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19055 17.907V21.183",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2952 18.2445V21.003",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70215 23.2904V24.9509",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1816 27.009V30.0225",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49609 27.009V30.1725",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4911 31.1655C15.7247 31.1655 15.9141 30.9761 15.9141 30.7425C15.9141 30.5088 15.7247 30.3195 15.4911 30.3195C15.2575 30.3195 15.0681 30.5088 15.0681 30.7425C15.0681 30.9761 15.2575 31.1655 15.4911 31.1655Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8096 27.1125C15.8667 27.1125 15.9131 27.0662 15.9131 27.009C15.9131 26.9519 15.8667 26.9055 15.8096 26.9055C15.7524 26.9055 15.7061 26.9519 15.7061 27.009C15.7061 27.0662 15.7524 27.1125 15.8096 27.1125Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7139 27.1125C13.771 27.1125 13.8174 27.0662 13.8174 27.009C13.8174 26.9519 13.771 26.9055 13.7139 26.9055C13.6567 26.9055 13.6104 26.9519 13.6104 27.009C13.6104 27.0662 13.6567 27.1125 13.7139 27.1125Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M111.405 27.108C111.405 27.6705 110.949 28.1265 110.387 28.1265C109.824 28.1265 109.368 27.6705 109.368 27.108C109.368 26.745 109.559 26.4255 109.844 26.2455C110.001 26.1465 110.187 26.0895 110.387 26.0895C110.949 26.0895 111.405 26.5455 111.405 27.108Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M109.939 26.3955L110.858 27.8055",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M112.895 29.7464C112.895 30.3089 112.439 30.7649 111.877 30.7649C111.314 30.7649 110.858 30.3089 110.858 29.7464C110.858 29.3834 111.049 29.0639 111.334 28.8839C111.491 28.7849 111.677 28.7279 111.877 28.7279C112.439 28.7279 112.895 29.1839 112.895 29.7464Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M111.428 29.0339L112.347 30.4439",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M114.838 21.4905C114.981 21.4905 115.097 21.3743 115.097 21.231C115.097 21.0877 114.981 20.9715 114.838 20.9715C114.694 20.9715 114.578 21.0877 114.578 21.231C114.578 21.3743 114.694 21.4905 114.838 21.4905Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1982 20.3475C74.3183 20.3475 74.4157 20.2501 74.4157 20.13C74.4157 20.0099 74.3183 19.9125 74.1982 19.9125C74.0781 19.9125 73.9807 20.0099 73.9807 20.13C73.9807 20.2501 74.0781 20.3475 74.1982 20.3475Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1986 29.7465C74.2872 29.7465 74.3591 29.6747 74.3591 29.586C74.3591 29.4974 74.2872 29.4255 74.1986 29.4255C74.1099 29.4255 74.0381 29.4974 74.0381 29.586C74.0381 29.6747 74.1099 29.7465 74.1986 29.7465Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1142 20.6894C60.1714 20.6894 60.2177 20.6431 60.2177 20.5859C60.2177 20.5288 60.1714 20.4824 60.1142 20.4824C60.0571 20.4824 60.0107 20.5288 60.0107 20.5859C60.0107 20.6431 60.0571 20.6894 60.1142 20.6894Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.708 18.384V16.887L11.1545 16.443V15.723L12.9275 14.67H15.2L23.2925 16.9425H53.9975V15.7785L50.783 15.5565L50.7275 14.67H53.0555L53.4995 13.95H55.3835L55.772 14.7255C55.772 14.7255 57.047 14.3715 57.6005 15.324C58.154 16.2765 58.4315 16.7205 58.4315 16.7205H59.54L61.2575 17.22C61.2575 17.22 62.255 17.2755 62.366 18.051L63.197 18.384H71.954L72.6185 17.7975H80.3225L80.711 18.384H82.1525L83.2055 17.4975L115.739 17.442L117.347 18.384V30.855L115.85 32.463H114.188L113.635 32.13L110.864 32.463C110.864 32.463 109.091 28.473 106.541 27.6405C103.991 26.8095 98.339 26.31 97.7285 26.31C97.118 26.31 96.0665 25.866 96.011 25.0905L91.8545 25.035C91.8545 25.035 88.085 26.4765 87.92 28.638C87.7535 30.7995 89.2505 30.966 90.137 33.516C91.0235 36.066 92.132 37.728 90.3035 38.3385C88.475 38.9475 86.5895 39.6135 86.5895 39.6135C86.5895 39.6135 85.259 39.9465 85.7585 38.4495C86.258 36.9525 83.7635 31.7985 83.7635 31.7985C83.7635 31.7985 83.486 30.912 82.433 30.912H69.0755V30.261H67.9115V31.1325H67.136V28.251L66.5825 27.5865H55.664L55.775 29.526L55.055 30.579L49.901 30.801C49.901 30.801 49.292 30.6345 49.292 31.521L48.9185 31.9785H45.593L45.1565 32.394H44.117L43.6385 31.9365H42.7445L42.287 32.373H41.123L40.769 31.9785H39.833L39.4175 32.352H38.2955L37.859 31.9365H36.923L36.59 32.331H35.384L35.0105 31.9155H34.0955L33.659 32.352H32.516L32.0795 31.9155H30.2915L25.3865 30.897C25.3865 30.897 24.4925 30.7095 24.4925 29.8785H19.379V30.336H17.903L17.945 32.289L17.5505 32.6835H14.4125L13.934 32.247L13.061 29.94H12.1055L11.378 30.252L7.28304 30.1695L6.36804 29.5875V27.4335L7.19904 26.886H11.7305L11.357 25.3695H4.01754L3.47754 24.954V23.229L4.01754 22.71H6.42804V21.504H4.74504C4.74504 21.504 4.16304 20.763 4.10004 19.605C4.03704 18.4485 4.76454 17.799 4.76454 17.799H8.06904L8.56854 18.261H9.92004L10.1285 17.907L10.544 17.886L10.793 18.2595L11.708 18.384V18.384Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69702 21.501H8.23702L8.67352 21.1065H9.92152L10.316 21.303L10.877 21.003H11.708V22.998H9.70252L9.08902 22.311H7.69702V21.501Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4181 21.003H13.1211V22.998H16.4181V21.003Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2406 21.003H17.9706V22.998H21.2406V21.003Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0657 26.796H19.4677L18.8857 25.284H25.0657V26.796Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9706 22.998V25.035L18.8856 26.796V30.3615",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6222 22.7955H117.346",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3126 17.718V21.765",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3661 18.051V21.765",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2402 21.003H25.3982L26.8382 21.321H34.5977L35.5952 21.7095V22.998L34.5977 23.5935H26.7827L25.7297 24.0915H21.2402V21.003Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5956 21.7095L48.4536 21.765H90.1326L92.2941 23.2605L91.2801 25.284",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4531 21.7651V26.2816L48.7441 26.7961V31.6021",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7021 21.9586V27.5836H73.7267L75.1681 26.3086H82.2061V24.7711L84.9782 22.9981H91.6216",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6506 29.7465H76.1931V27.4455H80.6826H82.6506V29.7465Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2954 27.8475C80.2954 27.8475 80.2489 28.485 80.0269 28.9095C79.9684 29.022 80.0899 29.148 80.2069 29.0955C80.3749 29.0205 80.5654 28.9065 80.7394 28.7325C81.1834 28.2885 81.1279 27.846 81.1279 27.846H80.2969L80.2954 27.8475Z",
    fill: "#FAFAFB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9922 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1553 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3193 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4836 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6475 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8116 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9756 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1377 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3018 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4658 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6299 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7942 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9581 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1221 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2861 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4502 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6141 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7783 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9421 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1064 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2705 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4336 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5966 16.3785V16.9425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5492 32.6835V17.22H15.4912V21.003",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3557 25.3665H16.0732V22.998",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7295 26.8845L13.06 29.94",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7081 18.384L11.7291 25.3665",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42969 21.501H7.69719",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42969 22.707H9.25569",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12714 19.083H3.22864C3.22864 19.083 2.74414 19.173 2.74414 19.6995C2.74414 20.226 3.07714 20.379 3.21514 20.4195C3.35314 20.46 4.31014 20.4195 4.31014 20.4195",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M107.951 17.0536C107.951 17.0536 107.869 16.0005 109.171 16.0005H114.049C114.049 16.0005 115.351 15.9736 115.351 17.0536",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShotgunVariant);
export default __webpack_public_path__ + "static/media/Shotgun Variant.5dd52bf16fd2d5ae23e10ab540257ef4.svg";
export { ForwardRef as ReactComponent };